var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-container", { staticClass: "container" }, [
    _c(
      "main",
      [
        !_vm.guid ? _c("password") : _vm._e(),
        _vm._v(" "),
        _vm.guid
          ? _c(
              "div",
              [
                _c("h2", [_vm._v("Confirm New Password")]),
                _vm._v(" "),
                _vm.confirmPasswordStatus == "pending"
                  ? _c("el-alert", {
                      attrs: { type: "info", title: "Confirming..." }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.confirmPasswordStatus == "success"
                  ? _c("el-alert", {
                      attrs: {
                        type: "success",
                        title:
                          "Your password has been successfully reset. You may now log in."
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.confirmPasswordStatus == "failure"
                  ? _c("el-alert", {
                      attrs: {
                        type: "error",
                        title: "There was a problem resetting your password."
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("aside", [_c("login")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }